import { CompletionCondition } from '@insio/shared-types';

/** What a requisition or order under way waits for; shared by both display statuses. */
export const AwaitingCompletionStatus = {
  /** The account still requires the delivery. */
  AWAITING_DELIVERY: 'AWAITING_DELIVERY',
  /** The account still requires the invoice. */
  AWAITING_INVOICE: 'AWAITING_INVOICE',
  AWAITING_DELIVERY_AND_INVOICE: 'AWAITING_DELIVERY_AND_INVOICE',
  /** Not completed, with no delivery or invoice named as missing. */
  AWAITING_COMPLETION: 'AWAITING_COMPLETION'
} as const;

export type AwaitingCompletionStatus =
  (typeof AwaitingCompletionStatus)[keyof typeof AwaitingCompletionStatus];

/** A document under way waits for what its unmet completion conditions name. */
export function awaitingCompletionStatus(
  conditions: readonly CompletionCondition[] | null | undefined
): AwaitingCompletionStatus {
  const delivery = conditions?.includes(CompletionCondition.DELIVERY_INCOMPLETE) ?? false;
  const invoice = conditions?.includes(CompletionCondition.INVOICING_INCOMPLETE) ?? false;
  if (delivery && invoice) return AwaitingCompletionStatus.AWAITING_DELIVERY_AND_INVOICE;
  if (delivery) return AwaitingCompletionStatus.AWAITING_DELIVERY;
  if (invoice) return AwaitingCompletionStatus.AWAITING_INVOICE;
  return AwaitingCompletionStatus.AWAITING_COMPLETION;
}
